<template lang="pug">
.input-text
  label.input-text__label(for="field-login-full-name") Full name
  input.input-text__input(
    id="field-login-full-name"
    type="text"
    placeholder=""
    v-model.trim="value"
    @change="changeFieldValue()"
    @keyup="changeFieldValue()"
  )
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'FieldFullName',

  data () {
    return {
      value: ''
    }
  },

  methods: {
    ...mapMutations([
      'changeField'
    ]),

    changeFieldValue () {
      this.changeField({
        name: 'fieldFullName',
        value: this.value
      })
    }
  }
}
</script>
